// extracted by mini-css-extract-plugin
export default {"ErrorFallback":"ErrorFallback--BQGLk"};